import { ColDef, ColumnState } from '@ag-grid-community/core';
import {
  FieldConfig,
  FilterType,
  FilterValue,
} from '@ideapa/common-interfaces';
import { getGridColumnType, mapFromColumnState } from './ag-grid-utils';
import { ContentAlignmentEnum, EntityListField } from './entity-list-field';
import { SharedEntityFacadeInterface } from './shared-entity-facade.interface';

export function getGridColumns(
  gridColumns: EntityListField[],
  visibleColumns: string[],
  excludeColumns: string[],
  prefix = ''
) {
  return gridColumns
    .filter((gc) => !excludeColumns.find((c) => c === gc.field))
    .map(
      (f) =>
        ({
          colId: f.field,
          field: `${prefix && prefix + '.'}${f.field}`,
          initialHide: !visibleColumns.find((c) => c === f.field),
          headerName: f.elementLabel,
          headerClass: `ag-${
            contentAlignmentMap[f.contentAlignment || ContentAlignmentEnum.Left]
          }-aligned-header`,
          type: getGridColumnType(f.filterType, f.fieldType),
          filterParams: { suppressAndOrCondition: true },
          cellStyle: {
            'text-align':
              contentAlignmentMap[
                f.contentAlignment || ContentAlignmentEnum.Left
              ],
          },
          cellRendererParams: {
            elementValues: f.elementValues,
            precision: f.precision,
          },

          sortable: f.sortable,
          floatingFilter: f.sortable === false ? false : undefined,
          filter: f.sortable === false ? false : undefined,
          sort: f.sort,
          maxWidth: f.maxWidth,
          minWidth:
            f.minWidth ??
            (f.filterType === FilterType.date ||
            f.filterType === FilterType.datetime
              ? 240
              : 200),
          valueGetter: f.valueGetter ? f.valueGetter : undefined,
        } as ColDef)
    );
}

export const getExcelFields = (
  fields: EntityListField[],
  columnState: ColumnState[],
  excludeColumns: string[] = []
) => {
  const sortedFields = columnState
    .filter((c) => !c.hide)
    .map((c) => fields.find((f) => c.colId === f.field))
    .filter((c) => c != null) as EntityListField[];

  return sortedFields
    .map((f) => {
      return {
        name: f.field,
        label: f.elementLabel,
        type: f.fieldType,
        elementValues: f.elementValues,
        hidden: f.exportHideColumn,
      } as FieldConfig;
    })
    .filter((gc) => !excludeColumns.find((c) => c === gc.name));
};

export function tabDownloadExcel<T>(
  sharedFacade: SharedEntityFacadeInterface<T>,
  gridColumns: EntityListField[],
  excludeColumns: string[],
  columnState: ColumnState[],
  fileName: string,
  filters: FilterValue[],
  limitedRelations?: string[]
) {
  const columns = getExcelFields(gridColumns, columnState, excludeColumns);
  const sort = mapFromColumnState(columnState);
  sharedFacade.downloadExcel(
    fileName,
    columns,
    filters,
    sort,
    limitedRelations
  );
}

// Oggetto di mapping usato per la proprietà cellStyle di AG Grid
const contentAlignmentMap = {
  [ContentAlignmentEnum.Left]: 'left',
  [ContentAlignmentEnum.Center]: 'center',
  [ContentAlignmentEnum.Right]: 'right',
};
